import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { getErrorMessage } from '@shared/services/error-handler/helpers/get-error-message';

@Pipe({
    name: 'parseErrorMessage'
})
export class ParseErrorMessagePipe implements PipeTransform {
    transform(error: any): string {
        return getErrorMessage(error);
    }
}
